"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKIconBadge = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../components");
var common_1 = require("../../common");
var Activities_1 = require("../../models/Activities");
require("./GKIconBadge.css");
var BadgeCatalog = (_a = {},
    _a[Activities_1.Activity.Planting] = {
        color: Activities_1.ActivityColor.Planting,
        icon: components_1.GKIconName.Planting,
    },
    _a[Activities_1.Activity.Fertilizer] = {
        color: Activities_1.ActivityColor.Fertilizer,
        icon: components_1.GKIconName.Fertilizer,
    },
    _a[Activities_1.Activity.CropProtection] = {
        color: Activities_1.ActivityColor.CropProtection,
        icon: components_1.GKIconName.Security,
    },
    _a[Activities_1.Activity.Irrigation] = {
        color: Activities_1.ActivityColor.Irrigation,
        icon: components_1.GKIconName.Irrigation,
    },
    _a[Activities_1.Activity.Harvest] = {
        color: Activities_1.ActivityColor.Harvest,
        icon: components_1.GKIconName.Harvest,
    },
    _a[Activities_1.Activity.Tillage] = {
        color: Activities_1.ActivityColor.Tillage,
        icon: components_1.GKIconName.Tillage,
    },
    _a[Activities_1.Activity.Grazing] = {
        color: Activities_1.ActivityColor.Grazing,
        icon: components_1.GKIconName.Grazing,
    },
    _a);
/**
 * Simple HOC around GKBadge to configure pre-determined, icon-only badges.
 *
 * @example
 * `<GKIconBadge badge={Activity.Planting} />`
 *
 * @remarks
 * For the time being this is only Activities, but should be expanded to include other badge sets:
 * `badge: Activity | NewThing;` (add to the same badge catalog)
 *
 * Note: This component is provided as a courtesy/convenience and is not intended to be an
 * authority on specific feature data. We welcome MRs from feature teams to keep up to date.
 */
var GKIconBadge = function (_a) {
    var badge = _a.badge, baseProps = __rest(_a, ["badge"]);
    return (React.createElement(components_1.GKBadge, __assign({}, (0, common_1.mapDefaultProps)(baseProps, {
        _gkComponentName: "gk-icon-badge",
    }), BadgeCatalog[badge])));
};
exports.GKIconBadge = GKIconBadge;
exports.default = exports.GKIconBadge;
